module.exports = __webpack_public_path__ + "img/kink.5be018d.png";